import React, { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import { useForm } from "react-hook-form";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import { useCookies } from "react-cookie";
import { create, update } from "./Service";
import { API_URL } from "../../services/api";

const Formulario = ({ company, setShowModal, setMesssage, setPaginate }) => {
    const [token, setToken] = useCookies(["token"]);
    const [textButton, setTextButton] = useState("");
    const [response, setResponse] = useState("");

    useEffect(() => {
        if (company) {
            setTextButton("Editar");
        } else {
            setTextButton("Guardar");
        }
    }, [company]);

    useEffect(() => {
        if (response.message) {
            setMesssage(response);
        }
    }, [response]);

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();

    const onSubmit = async (data) => {
        if (company) {
            const updateResult = await update(data, company.id, token);
            setResponse(updateResult);
        } else {
            const createResult = await create(data, token);
            setResponse(createResult);
        }
        setShowModal(false);
        setPaginate(API_URL + "companies/pagination");
    };

    return (
        <Container>
            <Row className={`d-flex justify-content-center pt-3 pb-5`}>
                <Form className="col-12" onSubmit={handleSubmit(onSubmit)}>
                    <Col>
                        <Form.Group
                            className="mb-3"
                            controlId="exampleForm.ControlTextarea1"
                        >
                            <Form.Label>Nombre</Form.Label>
                            <Form.Control
                                size="sm"
                                type="text"
                                name="name"
                                defaultValue={company && company.name}
                                className={`input-border form-control  ${
                                    errors.company_id ? "is-invalid" : ""
                                }`}
                                {...register("name", {
                                    required: "Obligatory field",
                                })}
                            />
                        </Form.Group>
                    </Col>

                    <Col>
                        <Form.Group
                            className="mb-3"
                            controlId="exampleForm.ControlTextarea1"
                        >
                            <Form.Label>Teléfono</Form.Label>
                            <Form.Control
                                size="sm"
                                type="text"
                                name="phone"
                                defaultValue={company && company.phone}
                                className={`input-border form-control  ${
                                    errors.company_id ? "is-invalid" : ""
                                }`}
                                {...register("phone", {
                                    required: "Obligatory field",
                                })}
                            />
                            {errors.name && (
                                <div className="invalid-feedback">
                                    {errors.name.message}
                                </div>
                            )}
                        </Form.Group>
                    </Col>

                    <Col>
                        <Form.Group
                            className="mb-3"
                            controlId="exampleForm.ControlTextarea1"
                        >
                            <Form.Label>Correo</Form.Label>
                            <Form.Control
                                size="sm"
                                type="text"
                                name="mail"
                                defaultValue={company && company.mail}
                                className={`input-border form-control  ${
                                    errors.company_id ? "is-invalid" : ""
                                }`}
                                {...register("mail", {
                                    required: "Obligatory field",
                                })}
                            />
                            {errors.name && (
                                <div className="invalid-feedback">
                                    {errors.name.message}
                                </div>
                            )}
                        </Form.Group>
                    </Col>

                    <Col>
                        <Form.Group
                            className="mb-3"
                            controlId="exampleForm.ControlTextarea1"
                        >
                            <Form.Label>Rut</Form.Label>
                            <Form.Control
                                size="sm"
                                type="text"
                                name="rut"
                                defaultValue={company && company.rut}
                                className={`input-border form-control  ${
                                    errors.company_id ? "is-invalid" : ""
                                }`}
                                {...register("rut", {
                                    required: "Obligatory field",
                                })}
                            />
                            {errors.name && (
                                <div className="invalid-feedback">
                                    {errors.name.message}
                                </div>
                            )}
                        </Form.Group>
                    </Col>

                    <Col className="d-flex justify-content-between ">
                        <Button variant="primary" type="submit">
                            {textButton}
                        </Button>

                        <Button
                            variant="danger"
                            onClick={() => {
                                setShowModal(false);
                            }}
                        >
                            Cancelar
                        </Button>
                    </Col>
                </Form>
            </Row>
        </Container>
    );
};

export default Formulario;
